import { render, staticRenderFns } from "./PoliciesDetail.vue?vue&type=template&id=3fc687d3&scoped=true&"
import script from "./PoliciesDetail.vue?vue&type=script&lang=ts&"
export * from "./PoliciesDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc687d3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc687d3')) {
      api.createRecord('3fc687d3', component.options)
    } else {
      api.reload('3fc687d3', component.options)
    }
    module.hot.accept("./PoliciesDetail.vue?vue&type=template&id=3fc687d3&scoped=true&", function () {
      api.rerender('3fc687d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/PoliciesDetail.vue"
export default component.exports